import { MaterialIcon } from "@website/icons/material";
import { SearchField } from "@website/ui/search-field";
import { InputTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import { useRouter } from "next/router";
import { ChangeEvent, Fragment, useCallback } from "react";
import { useFormContext } from "react-hook-form";

export const Input = (properties: InputTypes) => {
  const router = useRouter();
  const { title, search_key, type } = properties;
  const { setValue } = useFormContext();

  const setFilter = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      setValue(search_key, {
        type,
        withDebounce: true,
        value: event.target.value || undefined
      }),
    [search_key, setValue, type]
  );

  return (
    <Fragment>
      <span className={styles["filter-header"]}>{title}</span>
      <SearchField
        EndIcon={<MaterialIcon className="text-2xl" name="search" />}
        defaultValue={router.query[search_key]}
        disabled={false}
        fullWidth
        onChange={setFilter}
        placeholder={
          ["villa"].includes(process.env.NEXT_PUBLIC_APP_NAME ?? "")
            ? "نام اقامتگاه"
            : "نام هتل"
        }
        size="dense"
      />
    </Fragment>
  );
};
